var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 20,
    viewBox: "0 0 22 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.0078 5.71429L19.4648 0.0446429C19.3789 0.0446429 19.293 0 19.25 0H15.5117L10.0117 5.71429H14.0078ZM7.13281 5.71429L12.6328 0H8.63672L3.13672 5.71429H7.13281ZM21.3555 1.11607L16.8867 5.71429H22V2.85714C22 2.1875 21.7422 1.60714 21.3555 1.11607ZM5.75781 0H2.75C1.20312 0 0 1.29464 0 2.85714V5.71429H0.257812L5.75781 0ZM0 17.1429C0 18.75 1.20312 20 2.75 20H19.25C20.7539 20 22 18.75 22 17.1429V7.14286H0V17.1429Z",
    fill: "#185BFF"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.6a4812a7ec10c17fdd2951270633d966.svg";
export { ForwardRef as ReactComponent };